import React, { Component } from 'react'
import UserStatus from './UserStatus';

class ActiveUsers extends Component {

    render() {
        const users = [];

        if(this.props.users) {
            for(const key in this.props.users) {
                const user = this.props.users[key];
                users.push(<UserStatus key={key} name={user.firstName} status={user.active} />);
            }
        }

        return (
            <div className="tradersOnline">
            <h4>Traders Online</h4>
                { (!this.props.users) ? 'Currently, there are no active users online.' : users }
            </div>
        );
    }
}

export default ActiveUsers;